import React, { Component } from 'react';
import { connect } from 'react-redux';
import { setCatNav, categorySelectedTrigger } from './../redux/actions';
import PageWrapper from './../components/PageWrapper';
import Hero from './../components/hero/Hero';
import CategoryNavWrapper from './../components/filter-pages/CategoryNavWrapper';
import PublicationsGrid from './../components/filter-pages/PublicationsGrid';
import { filterCategory, splitString, removeHidden } from './../scripts';

class PublicationsLanding extends Component {
  componentWillMount() {
    this.props.setCatNav(this.props.staticContent.publicationsData.data.publications_landing_category_navigation);
    this.props.categorySelected(splitString(this.props.route));
  };
  render() {
    return (
      <PageWrapper pageId={'portfolio-landing'}>
        <Hero sliderContent={this.props.staticContent.publicationsData.data.hero_slider}/>
        <CategoryNavWrapper/>
        <PublicationsGrid
          GridItems={filterCategory(removeHidden(this.props.staticContent.publicationsData.data.publications_grid), this.props.category)}
          StocklistData={this.props.staticContent.stockListData.data}
          Locations={this.props.route}
        />
      </PageWrapper>
    );
  };
};

export default connect(
  state => ({
    route: state.router.location_data.pathname,
    staticContent: state.staticContent,
    category: state.current_sub_category
  }),
  dispatch => ({
    setCatNav: (navigation) => dispatch(setCatNav(navigation)),
    categorySelected: (category) => dispatch(categorySelectedTrigger(category))
  })
)(PublicationsLanding);



// WEBPACK FOOTER //
// ./src/pages/PublicationsLanding.js